// we can move it out into .env file probably. leaving here for now
export const RECAPTCHA_SITE_KEY = '6LcmBUwUAAAAANkHpH-EEB7CUIXsQcH5-vmIEsHs'
